'use es6';

import BaseContainer from './BaseContainer';
const JitaContainer = BaseContainer.create();
export default JitaContainer;